import React, { useEffect, useState } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      const timeout = setTimeout(() => setVisible(true), 1000); 
      return () => clearTimeout(timeout);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 max-w-xl mx-auto z-50 bg-eryndra-ivory text-eryndra-forest p-4 rounded-lg shadow-xl border border-eryndra-gold animate-fade-in">
      <p className="text-sm mb-2 font-bold">
        Utilizamos cookies técnicas para el funcionamiento de la web.{" "}
        <a href="/politica-cookies" className="underline text-eryndra-gold hover:text-eryndra-burgundy transition-colors">
        <p>Más información</p>
        </a>
        
      </p>
      <button
        onClick={acceptCookies}
        className="mt-2 btn-eryndra"
      >
        Aceptar
      </button>
    </div>
  );
}